const { scrollmagic } = require('./modules/scrollmagic');
const { pageTop } = require('./modules/pageTop');
const { smooth } = require('./modules/smooth');
const { fileUpload1, fileUpload2, fileUpload3, fileUpload4, fileUpload5, fileUpload6, fileUpload7, fileUpload8, fileUpload9, fileUpload10 } = require('./modules/fileUpload');
const { fileClear1, fileClear2, fileClear3, fileClear4, fileClear5, fileClear6, fileClear7, fileClear8, fileClear9, fileClear10 } = require('./modules/fileClear');

scrollmagic();
pageTop();
smooth();
fileUpload1();
fileUpload2();
fileUpload3();
fileUpload4();
fileUpload5();
fileUpload6();
fileUpload7();
fileUpload8();
fileUpload9();
fileUpload10();
fileClear1();
fileClear2();
fileClear3();
fileClear4();
fileClear5();
fileClear6();
fileClear7();
fileClear8();
fileClear9();
fileClear10();
